import dynamic from 'next/dynamic';

import { PartnerBlockBlockProps } from 'src/components/blocks/PartnerBlockBlock';
import { fetchProducts } from 'src/services/catalog';
import { ContentBlockRenderer } from 'src/types/Block';
import { AsyncTransformer } from 'src/types/Transformer';
import { lazyLoadImages } from 'src/utils/images';
import { contentPartnerToModel } from './contentToModel';
import { ContentPartner, PartnerBlockContentSection } from './types';
import { getProductsValidationErrors } from './validation';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<PartnerBlockBlockProps> =
  dynamic<PartnerBlockBlockProps>(() =>
    import('src/components/blocks/PartnerBlockBlock').then((mod) => mod.PartnerBlockBlock),
  );

const getAllProductCodesFromPartners = (partners: ContentPartner[]) =>
  partners
    .reduce((prev, curr) => prev.concat(curr.products as never), [])
    .map(({ product_code }) => Number(product_code));

export const transformer: AsyncTransformer<
  PartnerBlockContentSection,
  PartnerBlockBlockProps
> = async (
  { _metadata, heading, copy, partners, tracking_title },
  { pageConfig, pageMetadata, positionMetadata },
) => {
  const productCodes = getAllProductCodesFromPartners(partners);
  const catalogServiceProducts = await fetchProducts(productCodes);
  const renderableProducts = (catalogServiceProducts || [])?.filter(
    (product) => product.purchasable,
  );
  const errors = getProductsValidationErrors(
    productCodes,
    catalogServiceProducts,
    renderableProducts,
  );

  return {
    uid: _metadata.uid,
    props: {
      heading,
      copy,
      partners: partners.map((partner) => contentPartnerToModel(partner, renderableProducts)),
      trackingTitle: tracking_title,
      currency: pageMetadata.currency,
      pageType: pageConfig.pageType,
      lazyImages: lazyLoadImages(positionMetadata.position),
    },
    errors,
  };
};
